import { Flex } from '@chakra-ui/react';
import { Tag } from '@kula-ai/components';
import type { SuggestedActionChipsProps } from './SuggestedActionChips.types';

// Shared suggested-action chip row (candidate / profile / data-table blocks).
export const SuggestedActionChips = ({
  actions,
  onSelect,
  disabled = false,
  testIdPrefix,
}: SuggestedActionChipsProps) => (
  <Flex wrap="wrap" gap="8px">
    {actions.map((a) => (
      <Tag
        key={a.id}
        label={a.label}
        size="md"
        variant={a.kind === 'primary' ? 'primary' : 'outline'}
        disabled={disabled}
        onClick={() => onSelect(a.promptTemplate)}
        className="cursor-pointer"
        data-test-id={`${testIdPrefix}-${a.id}`}
      />
    ))}
  </Flex>
);
